import { render, staticRenderFns } from "./FooterCards.vue?vue&type=template&id=610d8d04&"
var script = {}
import style0 from "./FooterCards.vue?vue&type=style&index=0&id=610d8d04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports